import { SearchSessionState } from '../types'

import { SearchSessionReducerAction, SearchSessionAction } from './actionTypes'

export const searchSessionReducer = (
  state: SearchSessionState,
  action: SearchSessionAction,
): SearchSessionState => {
  switch (action.type) {
    case SearchSessionReducerAction.SET_SEARCH_SESSION_DATA: {
      const {
        searchCorrelationId,
        searchSessionId,
        globalSearchSessionId,
        globalCatalogBrowseSessionId,
      } = action.payload

      return {
        ...state,
        globalSearchSessionId: globalSearchSessionId || null,
        globalCatalogBrowseSessionId: globalCatalogBrowseSessionId || null,
        correlationId: searchCorrelationId || state.correlationId,
        sessionId: searchSessionId || state.sessionId,
      }
    }
    default:
      return state
  }
}
